import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { TAB_BUTTON_TYPE } from '../../global/constants';
import { FlexCenter } from '../../global/commonStyle';

interface WrapButton {
  variant?: number;
  size?: 'small' | 'medium';
  iconPosition?: 'start' | 'end' | 'none';
  disabled?: boolean;
  isActive?: boolean;
  applyFullWidth?: boolean;
}

export const TabsButton = styled.div<WrapButton>`
  ${FlexCenter}
  gap: var(--space-6);
  border-radius: var(--border-radius-8);
  padding: ${({ size }) => (size === 'medium' ? 'var(--space-6) var(--space-12)' : 'var(--space-3) var(--space-8)')};
  background-color: transparent;
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  white-space: nowrap;
  ${({ applyFullWidth }) =>
    applyFullWidth &&
    css`
      width: 100%;
    `}
  /* hover state */
  cursor: pointer;
  &:hover {
    background-color: var(--background-hover-navbar);
    color: var(--text-primary);
    svg path {
      fill: var(--text-primary);
    }
  }

  /* icon Position */
  ${({ iconPosition, size }) =>
    iconPosition === 'end' &&
    css`
      flex-direction: row-reverse;
      padding-inline: ${size === 'small' ? 'var(--space-8) var(--space-6)' : 'var(--space-12) var(--space-10)'};
    `}
  ${({ iconPosition, size }) =>
    iconPosition === 'start' &&
    css`
      flex-direction: row;
      padding-inline: ${size === 'small' ? 'var(--space-6) var(--space-8)' : 'var(--space-10)var(--space-12)'};
    `}
  
    /* Secondary button */
  ${({ variant }) =>
    variant === TAB_BUTTON_TYPE.PILL &&
    css`
      background-color: var(--background-primary);
      box-shadow: var(--border);
      &:hover {
        background-color: transparent;
        color: var(--text-primary);
        box-shadow: var(--border);
      }
    `}
    /* disabled state */
    ${({ disabled }) =>
    disabled &&
    css`
      background-color: transparent;
      color: var(--text-muted);
      cursor: not-allowed;
      pointer-events: none;
      svg path {
        fill: var(--text-muted);
      }
      &:hover {
        background-color: transparent;
        color: var(--text-muted);
        svg path {
          fill: var(--text-muted);
        }
      }
    `}
    /* active state */
    ${({ isActive }) =>
    isActive &&
    css`
      background-color: var(--background-active-navbar);
      color: var(--text-primary);
      svg path {
        fill: var(--text-primary);
      }
      &:hover {
        background-color: var(--background-active-navbar);
      }
    `}
`;

export const Icon = styled.div<WrapButton>`
  ${FlexCenter}
`;
